// extracted by mini-css-extract-plugin
module.exports = {"ExplorationCard":"ExplorationDetailsView_ExplorationCard__lQVl-"};